module.exports = __webpack_public_path__ + "static/media/phone.cbae574e.svg";